import script from "./AddEditStockView.vue?vue&type=script&setup=true&lang=js"
export * from "./AddEditStockView.vue?vue&type=script&setup=true&lang=js"

import "./AddEditStockView.vue?vue&type=style&index=0&id=6e5a69f7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e5a69f7"]])

export default __exports__